import React from 'react';
import { Star, Quote } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import TestimonialBanner from '../components/Testimonals/testimonialbanner';
import ReviewGrid from '../components/Testimonals/reviewgrid';


  
function TestimonialsPage() {
  return (
    <>
    <Header/>
    <TestimonialBanner/>
    <ReviewGrid/>
    <Footer/>
    </>
    
  );
};

export default TestimonialsPage;